// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuex from 'vuex';
import App from './App';
import router from './router';
import axios from 'axios';
import VuePaginate from 'vue-paginate';
import VueLazyload from 'vue-lazyload';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {
    getApiURL
} from './config';

Vue.use(VuePaginate);
Vue.use(VueLazyload, {
    preLoad: 1,
    attempt: 1,
});
Vue.use(ElementUI);
Vue.use(Vuex);

Vue.prototype.getApiURL = {
    getApiURL
};
axios.defaults.withCredentials = true;// 全局配置
Vue.prototype.$http = axios;

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: {
        App
    },
    data: {
        langs: ['PHP', 'JavaScript', 'HTML', 'CSS', 'Ruby', 'Python']
    }
});



// WEBPACK FOOTER //
// ./src/main.js